import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section id="final-cta" className="w-full bg-wine px-5 py-12 text-center md:py-20" aria-labelledby="final-heading" data-id="element-57">
      <div className="mx-auto max-w-container" data-id="element-58">
        <h2 id="final-heading" className="font-serif italic text-[26px] font-medium leading-tight text-cream md:text-[32px]" data-id="element-59">
          Tu nueva etapa empieza hoy
        </h2>
        <p className="mt-3 text-[16px] text-pinkLight" data-id="element-60">
          21 días para sentirte tú otra vez
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-61">
          <CTAButton variant="inverse" size="lg" className="w-full max-w-md" data-id="element-62">
            Sí, quiero mi guía por $10 →
          </CTAButton>
          <p className="mt-4 text-[12px] text-pinkLight" data-id="element-63">
            Acceso inmediato · Garantía 7 días · Pago 100% seguro
          </p>
        </div>
      </div>
    </section>;
}